import { Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';

export const routes: Routes = [
  {
    path: 'configuration',
    loadComponent: () =>
      import('./components/configuration/configuration.component').then(
        (m) => m.ConfigurationComponent
      ),
  },
  {
    path: 'configuration/incentive-programs',
    loadComponent: () =>
      import(
        './components/configuration/incentive-programs/incentive-programs.component'
      ).then((m) => m.IncentiveComponent),
  },
  {
    path: 'configuration/contributor',
    loadComponent: () =>
      import(
        './components/configuration/contributor/contributor-settings/contributor-settings.component'
      ).then((m) => m.ContributorSettingsComponent),
  },
  // Update the import path below to the correct location of FixedBurdenPlanComponent
  {
    path: 'configuration/plan/fixed-burden-plan',
    loadComponent: () =>
      import(
        './components/configuration/plans/fixed-burden-plan/fixed-burden-plan.component'
      ).then((m) => m.FixedBurdenPlanComponent),
  },
  {
    path: 'configuration/roles',
    loadComponent: () =>
      import('./components/configuration/roles/roles.component').then(
        (m) => m.RolesComponent
      ),
  },
  {
    path: 'configuration/plan',
    loadComponent: () =>
      import('./components/configuration/plans/plan.component').then(
        (m) => m.PlanComponent
      ),
  },
  {
    path: 'configuration/plan/commission-rate-template',
    loadComponent: () =>
      import(
        './components/configuration/plans/commission-rate-templates/commission-rate-templates.component'
      ).then((m) => m.CommissionRateTemplatesComponent),
  },
  {
    path: 'configuration/plan/permanent-plan',
    loadComponent: () =>
      import(
        './components/configuration/plans/permanent-plan/permanent-plan.component'
      ).then((m) => m.PermanentPlanComponent),
  },
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./components/Dashboard/my-dashboard/my-dashboard.component').then(
        (m) => m.MyDashboardComponent
      ),
  },
  {
    path: 'placement-ownership',
    loadComponent: () =>
      import(
        './components/placement-ownership/placement-ownership.component'
      ).then((m) => m.PlacementOwnershipComponent),
  },
   {
    path: 'commissions',
    loadComponent: () =>
      import(
        './components/my-commissions/my-commissions.component'
      ).then((m) => m.MyCommissionsComponent),
  },
     {
    path: 'commissions/estimator',
    loadComponent: () =>
      import(
        './components/my-commissions/commission-estimator/commission-estimator.component'
      ).then((m) => m.CommissionEstimatorComponent),
  },
     {
    path: 'ownerships',
    loadComponent: () =>
      import(
        './components/ownerships/ownerships.component'
      ).then((m) => m.OwnershipsComponent),
  },
  {
    path: 'prepareCommissions',
    loadComponent: () =>
      import(
        './components/prepare-commissions/prepare/prepare-commissions.component'
      ).then((m) => m.PrepareComponent),
  },

  {
    path: 'prepareCommissions/search-invoice',
    loadComponent: () =>
      import('./components/prepare-commissions/search-invoice/search-invoice.component').then(
        (m) => m.SearchInvoiceComponent
      ),
  },
  {
    path: 'prepareCommissions/ingestion-control',
    loadComponent: () =>
      import('./components/prepare-commissions/ingestion-control/ingestion-control.component')
        .then(m => m.IngestionControlComponent),
  },
    {
    path: 'configuration/pending-approvals',
    loadComponent: () =>
      import('./components/pending-approval/pending-approval/pending-approval.component')
        .then(m => m.PendingApprovalComponent),
  },



  {
    path: 'reports/assigned-incentive-programs',
    loadComponent: () =>
      import('./components/reports/assigned-incentive-programs/assigned-incentive-programs.component')
        .then(m => m.AssignedIncentiveProgramsComponent),
  },
  {
    path: 'reports/commission-rate-plan',
    loadComponent: () =>
      import('./components/reports/assigned-commission-plans/assigned-commission-plans.component')
        .then(m => m.AssignedCommissionPlansComponent),
  },
  {
    path: 'reports/unpaid-perm-invoices',
    loadComponent: () =>
      import('./components/reports/unpaid-perm-invoices/unpaid-perm-invoices.component')
        .then(m => m.UnpaidPermInvoicesComponent),
  },
  {
    path: 'reports/invoice-placement-calculations',
    loadComponent: () =>
      import('./components/reports/invoice-placement-calculations/invoice-placement-calculations.component')
        .then(m => m.InvoicePlacementCalculationsComponent),
  },
  {
    path: 'reports/reconciliation',
    loadComponent: () =>
      import('./components/reports/reconciliation/reconciliation.component')
        .then(m => m.ReconciliationComponent),
  },

  {
    path: 'reports/ownership-changes',
    loadComponent: () =>
      import('./components/reports/ownership-changes/ownership-changes.component')
        .then(m => m.OwnershipChangesComponent),
  },
  {
    path: 'reports/system-audit-history',
    loadComponent: () =>
      import('./components/reports/system-audit-history/system-audit-history.component')
        .then(m => m.SystemAuditHistoryComponent),
  },
  {
    path: 'reports/retroactive-changes',
    loadComponent: () =>
      import('./components/reports/retroactive-changes/retroactive-changes.component')
        .then(m => m.RetroactiveChangesComponent),
  },

  // HOME MUST COME BEFORE WILDCARD
  { path: 'home', component: HomeComponent },

  { path: '', redirectTo: 'home', pathMatch: 'full' },

  // WILDCARD MUST BE LAST
  { path: '**', redirectTo: 'home' },
];
